// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"d2601417","80":"a597bfe3","592":"f4bb3fa8"}[chunkId] + ".chunk.js";
};